import React, { useEffect, useState } from "react";
import ApiConfig from "../../common/config/ApiConfig";
import { useLanguage } from "../../common/i18n/LanguageContext";

const LOTTO_TYPE_LABEL_KEYS = {
  th_gov: "table_lotto_thai",
  hanoy_PhuQua: "lotto_type_hanoi",
  laos_gov: "table_lotto_laos",
  Yeekee_5: "lotto_type_yeekee",
  Yeekee_10: "lotto_type_yeekee_vip",
  Yeekee_15: "lotto_type_yeekee_vvip",
};

const formatAmount = (value) => {
  const floatValue = parseFloat(value);
  return isNaN(floatValue)
    ? "-"
    : floatValue.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
};

function LottoWaitResultType({ data = [] }) {
  const { t } = useLanguage();
  const [currencyCodeById, setCurrencyCodeById] = useState({});

  useEffect(() => {
    ApiConfig.get("/getCurrencyList").then((result) => {
      if (result.resCode !== 200) return;
      const list = Array.isArray(result.data) ? result.data : [];
      setCurrencyCodeById(Object.fromEntries(list.map((c) => [c.id, c.code])));
    });
  }, []);

  const withCurrency = (value, row) => {
    const text = formatAmount(value);
    const code = currencyCodeById[row.currency_id];
    return code && text !== "-" ? `${text} ${code}` : text;
  };

  return (
    <div className="overflow-x-auto rounded">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="bg-brand-blue-800 text-white">
            <th className="px-3 py-2 text-left">
              {t("fightlimit_col_game_type")}
            </th>
            <th className="px-3 py-2 text-right">
              {t("waitresult_bet_wager_label")}
            </th>
            <th className="px-3 py-2 text-right">
              {t("waitresult_bet_payout_label")}
            </th>
            <th className="px-3 py-2 text-left">
              {t("winlose_col_senior")}
            </th>
            <th className="px-3 py-2 text-left">
              {t("winlose_col_master")}
            </th>
            <th className="px-3 py-2 text-left">{t("winlose_col_agent")}</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={6} className="text-center py-4 text-gray-400">
                {t("common_no_data")}
              </td>
            </tr>
          ) : (
            data.map((row, index) => (
              <tr
                key={`${row.type ?? index}-${row.currency_id}`}
                className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                <td className="px-3 py-2">
                  <span className="font-bold">
                    {LOTTO_TYPE_LABEL_KEYS[row.type]
                      ? t(LOTTO_TYPE_LABEL_KEYS[row.type])
                      : row.type}
                  </span>
                </td>
                <td className="px-3 py-2 text-right font-semibold text-sky-600">
                  {withCurrency(row.bet_amount, row)}
                </td>
                <td className="px-3 py-2 text-right font-semibold text-red-600">
                  {withCurrency(row.payrateAmount, row)}
                </td>
                <td className="px-3 py-2 text-gray-700">
                  {withCurrency(row.seniorOutstanding, row)}
                </td>
                <td className="px-3 py-2 text-gray-700">
                  {withCurrency(row.masterOutstanding, row)}
                </td>
                <td className="px-3 py-2 text-gray-700">
                  {withCurrency(row.agentOutstanding, row)}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default LottoWaitResultType;
